import { useRouteMatch } from "@sg-protect/federation-runtime";
import { useIsRouteProtected } from "@sg-protect/federation-runtime/squide";
import { type ReactNode, useState } from "react";
import { useLocation } from "react-router";
import { useSession } from "../SessionProvider.tsx";
import { TrialReasonModal } from "./TrialReasonModal.tsx";

interface TrialReasonGateProps {
    children: ReactNode;
}

// Replaces the app instead of overlaying it: other gates, redirects and in-page modals must not compete with the modal.
export function TrialReasonGate({ children }: TrialReasonGateProps) {
    const { isTrialReasonRequired } = useSession();
    const location = useLocation();
    const isProtectedRoute = useIsRouteProtected(useRouteMatch(location, { throwWhenThereIsNoMatch: false }));
    const [hasSubmitted, setHasSubmitted] = useState(false);

    const isBlocking = isTrialReasonRequired && !hasSubmitted && isProtectedRoute;

    if (isBlocking) {
        return <TrialReasonModal onSubmitted={() => setHasSubmitted(true)} />;
    }

    return children;
}
